import 'twin.macro';

import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { useEffect } from 'react';
import tw from 'twin.macro';

import CloseIcon from '@/assets/images/icons/CloseIcon';

import { BodyText } from '.';

const Modal = ({
  setOpen,
  open = false,
  children,
  title,
  twStyle,
  headerStyle,
  wrapperStyle,
  outsideClose = true,
  withBlur = false,
  withCloseIcon = true
}) => {
  const handleClose = () => {
    setOpen(false);
  };

  const handleOutside = e => {
    if (outsideClose) {
      e.preventDefault();
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) {
      document.documentElement.style.overflow = 'hidden';
      return () => {
        document.documentElement.style = {};
      };
    }
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        <div
          css={[
            tw`min-h-screen overflow-y-scroll w-full bg-modal flex fixed top-0 left-0 bottom-0 right-0 z-50 sm:p-5 !mt-[-5px] text-center`,
            wrapperStyle
          ]}
          onClick={handleOutside}
        >
          <motion.div
            css={[twStyle]}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            transition={{ duration: '0.5' }}
            tw='p-8 m-auto bg-primary'
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <div tw='flex justify-between' css={[headerStyle]}>
              <BodyText text={title} variant='bold' />
              <div tw='self-center !rounded-xl'>{withCloseIcon && <CloseIcon onClick={handleClose} />}</div>
            </div>
            <div>{children}</div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};
export { Modal };
